import React from 'react';
import { Link } from 'react-router-dom';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { toTestId } from '../../../utils/helpers/toTestId';

export const NavBarOption = ({ activePage, path, label }) => {
  const { tempedgeTranslator } = useTempEdgeTranslator();

  return (
    <li className={activePage === path ? 'active' : ''} data-testid={`navbar-option-${toTestId(label)}`}>
      <Link to={path}>{tempedgeTranslator(label)}</Link>
    </li>
  );
};
